<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('customers.customers.customer_type')"
            :error="errors.customer_type"
        >
            <DSelect
                id="customer_type"
                v-model="form.customer_type"
                :options="customerTypeOptions"
                :placeholder="__('customers.customers.select_customer_type')"
                :is-valid="isFormFieldValid('customer_type')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.company')"
            :error="errors.company"
        >
            <DInput
                id="company"
                v-model="form.company"
                :placeholder="__('customers.common.company')"
                :is-valid="isFormFieldValid('company')"
                maxlength="128"
                @keyup.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.title')"
            :error="errors.title"
        >
            <DSelect
                id="title"
                v-model="form.title"
                :options="titles"
                :placeholder="__('customers.common.select_title')"
                :is-valid="isFormFieldValid('title')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.firstname')"
            :error="errors.firstname"
        >
            <DInput
                id="firstname"
                v-model="form.firstname"
                :placeholder="__('customers.common.firstname')"
                :is-valid="isFormFieldValid('firstname')"
                maxlength="128"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.lastname')"
            :error="errors.lastname"
        >
            <DInput
                id="lastname"
                v-model="form.lastname"
                :placeholder="__('customers.common.lastname')"
                :is-valid="isFormFieldValid('lastname')"
                maxlength="128"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.address1')"
            :error="errors.address1"
        >
            <DInput
                id="address1"
                v-model="form.address1"
                :placeholder="__('customers.common.address1')"
                :is-valid="isFormFieldValid('address1')"
                maxlength="128"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.address2')"
            :error="errors.address1"
        >
            <DInput
                id="address2"
                v-model="form.address2"
                :placeholder="__('customers.common.address2')"
                :is-valid="isFormFieldValid('address2')"
                maxlength="128"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.postal_code')"
            :error="errors.postal_code"
        >
            <DInput
                id="postal_code"
                v-model="form.postal_code"
                :placeholder="__('customers.common.postal_code')"
                :is-valid="isFormFieldValid('postal_code')"
                maxlength="12"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.city')"
            :error="errors.city"
        >
            <DInput
                id="city"
                v-model="form.city"
                :placeholder="__('customers.common.city')"
                :is-valid="isFormFieldValid('city')"
                maxlength="45"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.country')"
            :error="errors.country_code"
        >
            <DSelect
                id="country_code"
                v-model="form.country_code"
                :options="countries"
                :is-valid="isFormFieldValid('country_code')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.customer_language')"
            :error="errors.customer_language"
        >
            <DSelect
                id="country_code"
                v-model="form.customer_language"
                :options="getAvailableLanguagesOption"
                :is-valid="isFormFieldValid('customer_language')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.email')"
            :error="errors.email"
        >
            <DInput
                id="email"
                v-model="form.email"
                :placeholder="__('customers.common.email')"
                :is-valid="isFormFieldValid('email')"
                maxlength="128"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.invoice_email')"
            :error="errors.invoice_email"
        >
            <DInput
                id="invoice_email"
                v-model="form.invoice_email"
                :placeholder="__('customers.customers.invoice_email')"
                :is-valid="isFormFieldValid('invoice_email')"
                maxlength="128"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.invoice_delivery_type')"
            :error="errors.invoice_delivery_type_id"
        >
            <DSelect
                id="invoice_delivery_type_id"
                v-model="form.invoice_delivery_type_id"
                :options="invoiceDeliveryTypes"
                :is-valid="isFormFieldValid('invoice_delivery_type_id')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.phone')"
            :error="errors.phone"
        >
            <DPhoneInput
                id="phone"
                v-model="form.phone"
                :is-valid="isFormFieldValid('phone')"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.fax')"
            :error="errors.fax"
        >
            <DPhoneInput
                id="fax"
                v-model="form.fax"
                :is-valid="isFormFieldValid('fax')"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.brand') "
            :error="errors.brand_id"
        >
            <DSelect
                id="brand"
                v-model="form.brand_id"
                :options="brands"
                :placeholder="__('customers.customers.brand')"
                :is-valid="isFormFieldValid('brand_id')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.original_brand') "
            :error="errors.original_brand_id"
        >
            <DSelect
                id="original_brand"
                v-model="form.original_brand_id"
                :options="originalBrands"
                :placeholder="__('customers.customers.original_brand')"
                :is-valid="isFormFieldValid('original_brand_id')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.payment_method')"
            :error="errors.payment_method"
        >
            <DSelect
                id="payment_method"
                v-model="form.payment_method"
                :options="paymentMethods"
                :placeholder="__('customers.customers.select_payment_method')"
                :is-valid="isFormFieldValid('payment_method')"
            />
        </DFormRow>
        <DFormRow
            v-if="form.payment_method === paymentMethodSepa"
            :label="__('customers.customers.iban')"
            :error="errors.iban"
        >
            <DInput
                id="iban"
                v-model="form.iban"
                :placeholder="__('customers.customers.iban')"
                :is-valid="isFormFieldValid('iban')"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            v-if="form.payment_method === paymentMethodSepa"
            :label="__('customers.customers.bic')"
            :error="errors.bic"
        >
            <DInput
                id="bic"
                v-model="form.bic"
                :placeholder="__('customers.customers.bic')"
                :is-valid="isFormFieldValid('bic')"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            v-if="form.payment_method === paymentMethodSepa"
            :label="__('customers.customers.account_owner')"
            :error="errors.account_owner"
        >
            <DInput
                id="account_owner"
                v-model="form.account_owner"
                :placeholder="__('customers.customers.account_owner')"
                :is-valid="isFormFieldValid('account_owner')"
                maxlength="128"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.dunning_block_until')"
            :error="errors.dunning_block_until"
        >
            <DDateFormatInput
                id="dunning_block_until"
                v-model="form.dunning_block_until"
                format="YYYY-MM-DD"
                type="date"
                :placeholder="__('customers.customers.dunning_block_until')"
                :disabled="!userPermissions.includes('dunning.stop')"
                :is-valid="isFormFieldValid('dunning_block_until')"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.payment_term')"
            :error="errors.payment_term"
        >
            <DSelect
                id="payment_term"
                v-model="form.payment_term"
                :options="paymentTerms"
                :placeholder="__('customers.customers.select_payment_term')"
                :is-valid="isFormFieldValid('payment_term')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.billing_type')"
            :error="errors.billing_type"
        >
            <DSelect
                id="billing_type"
                v-model="form.billing_type"
                :options="billingTypes"
                :placeholder="__('customers.customers.billing_type')"
                :is-valid="isFormFieldValid('billing_type')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.vat_number')"
            :error="errors.vat_number"
        >
            <DInput
                id="vat_number"
                v-model="form.vat_number"
                :placeholder="__('customers.customers.vat_number')"
                :is-valid="isFormFieldValid('vat_number')"
                maxlength="45"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.tax_exemption')"
            :error="errors.tax_exemption_id"
        >
            <DSelect
                id="tax_exemption"
                v-model="form.tax_exemption_id"
                :options="taxExemptions"
                :placeholder="__('customers.customers.select_tax_exemption')"
                :is-valid="isFormFieldValid('tax_exemption_id')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.brand_customer_number')"
            :error="errors.brand_customer_number"
        >
            <DInput
                id="brand_customer_number"
                v-model="form.brand_customer_number"
                :placeholder="__('customers.customers.brand_customer_number')"
                :is-valid="isFormFieldValid('brand_customer_number')"
                maxlength="45"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.birthday')"
            :error="errors.birthday"
        >
            <DDateFormatInput
                id="birthday"
                v-model="form.birthday"
                format="YYYY-MM-DD"
                type="date"
                :placeholder="__('customers.customers.birthday')"
                :is-valid="isFormFieldValid('birthday')"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.customer_segments')"
        >
            <DMultiSelect
                id="customer_segments"
                :options="customerSegments"
                :search="true"
                :selected="form.customer_segments"
                :selection="true"
                options-empty-placeholder="No options placeholder"
                :search-placeholder="__('customers.customers.assign_segments')"
                selection-type="tags"
                @update="updateSelectedSegments"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.is_reseller')"
            :error="errors.is_reseller"
        >
            <DTriStateCheckbox
                id="is_reseller"
                v-model="form.is_reseller"
                :is-valid="isFormFieldValid('is_reseller')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.communication_preferences')"
            :error="errors.communication_subscriptions_types"
        >
            <DMultiSelect
                id="search_communication_subscriptions"
                :options="communicationSubscriptionsTypes"
                :search="true"
                :selected="form.communication_subscriptions_types"
                :selection="true"
                options-empty-placeholder="No options placeholder"
                selection-type="tags"
                @update="updateSelectedCommunicationSubscriptionTypes"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.status')"
            :error="errors.status"
        >
            <DSelect
                id="status"
                v-model="form.status"
                :options="statusOptions"
                :placeholder="__('customers.customers.status')"
                :is-valid="isFormFieldValid('status')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.notes')"
            :error="errors.notes"
        >
            <DFormTextarea
                id="notes"
                v-model="form.notes"
                :placeholder="__('customers.customers.notes')"
                :is-valid="isFormFieldValid('notes')"
                @keydown.enter.exact.prevent="submitForm"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.dunning_stop_enabled')"
            :error="errors.dunning_stop"
        >
            <DTriStateCheckbox
                id="dunning_stop"
                v-model="form.dunning_stop"
                :is-valid="isFormFieldValid('dunning_stop')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.orders_blocked_flag')"
            :error="errors.orders_blocked"
        >
            <DTriStateCheckbox
                id="orders_blocked"
                v-model="form.orders_blocked"
                :is-valid="isFormFieldValid('orders_blocked')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.market_region')"
            :error="errors.market_regions"
        >
            <DMultiSelect
                id="market-region-dropdown"
                :options="marketRegionOptions"
                :search="true"
                :selection="true"
                :options-empty-placeholder="__('customers.customers.market_region')"
                selection-type="text"
                @update="updateMarketRegions"
            />
        </DFormRow>

        <DFabs>
            <DFab
                id="btn-search"
                :disabled="isInLoadingState"
                icon="magnify"
                :label="__('messages.search')"
                @click="submitForm"
            />
            <DFab
                icon="close"
                color="secondary"
                @click="$inertia.get($route('customers.customers.index'))"
            />
        </DFabs>
    </DForm>
</template>

<script>

const paymentMethodSepa = 'sepa'

export const defaultFieldValues = {
    firstname: null,
    lastname: null,
    title: null,
    company: null,
    address1: null,
    address2: null,
    postal_code: null,
    city: null,
    country_code: null,
    customer_language: null,
    email: null,
    invoice_email: null,
    phone: null,
    phone_pin: null,
    fax: null,
    brand_id: null,
    original_brand_id: null,
    payment_method: null,
    dunning_block_until: null,
    payment_term: null,
    billing_type: null,
    vat_number: null,
    tax_exemption_id: null,
    brand_customer_number: null,
    customer_type: null,
    iban: null,
    bic: null,
    account_owner: null,
    is_reseller: null,
    invoice_delivery_type_id: null,
    customer_segments: [],
    birthday: null,
    communication_subscriptions_types: null,
    status: null,
    notes: null,
    dunning_stop: null,
    orders_blocked: null,
    market_regions: []
}

export default {
    name: 'SearchCustomerForm',
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        countries: {
            type: Array,
            default: () => { return [] }
        },
        brands: {
            type: Array,
            default: () => { return [] }
        },
        originalBrands: {
            type: Array,
            default: () => { return [] }
        },
        titles: {
            type: Array,
            default: () => { return [] }
        },
        customerTypes: {
            type: Array,
            default: () => { return [] }
        },
        paymentTerms: {
            type: Array,
            default: () => { return [] }
        },
        paymentMethods: {
            type: Array,
            default: () => { return [] }
        },
        taxExemptions: {
            type: Array,
            default: () => { return [] }
        },
        billingTypes: {
            type: Array,
            default: () => { return [] }
        },
        customerSegments: {
            type: Array,
            default: () => { return [] }
        },
        statusOptions: {
            type: Array,
            default: () => { return [] }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        invoiceDeliveryTypes: {
            type: Array,
            default: () => { return [] }
        },
        languages: {
            type: Array,
            default: () => { return [] }
        },
        communicationSubscriptionsTypes: {
            type: Array,
            default: () => { return [] }
        },
        marketRegions: {
            type: Array,
            default: () => { return [] }
        }
    },
    emits: ['search'],
    data () {
        return {
            paymentMethodSepa,
            form: this.$inertia.form(Object.assign({}, defaultFieldValues))
        }
    },
    computed: {
        customerTypeOptions () {
            const types = this.customerTypes

            for (const index in types) {
                if (types[index].label.length !== 0) {
                    types[index].label = this.__(`customers.customers.customer_types.${types[index].value}`)
                }
            }

            return types
        },
        userPermissions () {
            return this.$page.props.auth.permissions
        },
        getAvailableLanguagesOption () {
            return this.languages
                .map((option) => ({ label: option.text, value: option.value }))
        },
        marketRegionOptions () {
            return this.marketRegions.map((item) => {
                return {
                    value: item.value,
                    text: item.label,
                    selected: this.form.marketRegions?.includes(String(item.value))
                }
            })
        },
    },
    methods: {
        submitForm () {
            this.$emit('search', this.form)
        },
        updateSelectedSegments (values) {
            this.form.customer_segments = values
        },
        updateSelectedCommunicationSubscriptionTypes (values) {
            this.form.communication_subscriptions_types = values
        },
        updateMarketRegions (values) {
            this.form.market_regions = values
        }
    }
}
</script>
